import React from "react";
import { useTranslation } from "react-i18next";
export const Cita = ({ cita, autor, image }) => {
  const [t] = useTranslation("global");


let inputs = [1, "Turing", {x:2}, [3, 4]];

delete inputs[1];
console.log(inputs.length);


  return (
    <div className="mt-24 flex flex-col justify-center items-center mb-16  sm:mb-5 sm:text-sm xs:mx-3 xs:mb-5"
      

    >
      <div className="p-5 mx-10 tabletbig:mx-28 bg-gray-50 ring-2 ring-gray-200 shadow-lg sm:mx-3 rounded-xl my-3 font-Poppins mobile:text-sm">
        <p className="font-medium font-Poppins text-lg text-gray-500 text-center mt-4">
          <span className="font-extrabold text-smt tabletbig:text-xl">"</span>
          {t(cita)}
          <span className="font-extrabold text-smt tabletbig:text-xl">"</span>
          <br />
          <br />
          <span className="text-center font-semibold font-Montserrat">
            {autor}
          </span>
        </p>
        {image}
      </div>
    </div>
  );
};
